import { Thread } from '../../types/threads/Thread'

export const SET_THREADS = 'SET_THREADS'

export interface SetThreadsAction {
  type: typeof SET_THREADS
  payload: Thread[]
}
